import {EditButton} from 'forms-editable';
import {FixedAspectRatioDiv} from '@rcm/fixed-aspect-ratio-div-react';
import {PwsHomePageProductData} from './types';
import {SafeHtml, Button} from 'forms';
import React from 'react';
import subdivide from 'rodash/subdivide';
import t from 'rcm-i18n';

interface Props {
    isEditing: boolean;
    onEditProduct: (productIndex: number) => void;
    onAddProduct: (productIndex: number) => void;
    products: PwsHomePageProductData[];
}

const ProductsTable = ({
    isEditing,
    onEditProduct,
    onAddProduct,
    products,
}: Props) => <div className="multi-add-to-cart-product-table">
    {subdivide(
        products
            .map((p, n) => [p, n] as const)
            .filter(([p]) => (
                isEditing ||
                (p && (p.skuOptions && p.skuOptions.length > 0))
            )),
        3
    ).map((productRow, i) =>
        <div className="multi-add-to-cart-product-row" key={i}>
            {productRow.map(([product, n]) =>
                <div key={n}
                        className="multi-add-to-cart-product-cell editable">
                    {(product.skuOptions && product.skuOptions.length > 0) && <>
                        <a href={product.detailPageUrl}>
                            <div className="imageContainer">
                                <FixedAspectRatioDiv aspectRatio="4:3">
                                    <img src={product.image} />
                                </FixedAspectRatioDiv>
                            </div>
                        </a>
                        <div className="header">{product.name}</div>
                        <SafeHtml className="bodyText"
                            html={product.description} />
                        <div className="multi-add-to-cart-product-product-bottom">
                            <div className="price">
                                {t('Retail')}: {
                                    (product.skuOptions.find((sku) =>
                                        sku.isDefault)
                                        || product.skuOptions[0]
                                    )
                                    .formattedRetailPrice
                                }
                            </div>
                            <div>
                                <Button
                                    btn="primary"
                                    text={t('Add to Cart')}
                                    onClick={() => onAddProduct(n)}
                                />
                            </div>
                        </div>
                    </>}
                    {isEditing && <EditButton onClick={
                        () => onEditProduct(n)
                    } />}
                </div>
            )}
        </div>
    )}
</div>;

export default ProductsTable;
